import React from 'react'
import { graphql } from 'gatsby'
import { TableOfContents, Section, Link, Image, SEO } from 'newComponents'
import ClosingCtas from '../components/ClosingCTAs'
import Layout from '../components/layout.js'
import starsBg from '../images/ebook/stars.jpg'
import arrow from '../images/ebook/arrow-right.svg'
import generatePath from '../../config/generatePath'

import * as Slices from '../slices'
import './ebook.scss'

export const Slice = ({ data, location }) => {
  const { slice_type: sliceType } = data
  const allSlices = { ...Slices }
  // Convert slice type from snake_case to TitleCase
  if (!sliceType) return null
  const sliceName = sliceType
    .split('_')
    .map((item) => item.charAt(0).toUpperCase() + item.substring(1))
    .join('')

  const CustomSlice = allSlices[sliceName]
  return <CustomSlice data={data} location={location} isEbook />
}

const Ebook = ({ data: staticData, location, pageContext }) => {
  // const data = setupPreviewData(staticData);
  // page data

  const { chapter, allChapters } = staticData
  const { nodes: chapters } = allChapters
  const { data: pageData, uid } = chapter

  const {
    body: sliceData,
    metaTitle,
    metaDesc,
    ogImage,
    title,
    chapter: chapterNumber,
    ebook_name: ebookName,
    chapter_image: chapterImage
  } = pageData

  // seo data
  const seo = {
    title: metaTitle?.text || title.text,
    description: metaDesc?.text || ebookName,
    ogImage: ogImage?.url
  }

  const anchorPoints = []

  sliceData.forEach((slice) => {
    const { slice_type: sliceType } = slice
    if (sliceType === 'anchor_title') {
      anchorPoints.push(slice?.primary)
    }
  })

  return (
    <Layout>
      <SEO {...seo} />
      <Section className="ebook">
        <div className="ebook-container">
          <TableOfContents anchorPoints={anchorPoints} pages={chapters} chapterIndex={chapterNumber} />
          <div className="ebook-content">
            <Image className="ebook-header" image={chapterImage || starsBg} />
            <div className="blog-post-slice-content">
              {sliceData.map((slice) => (
                <Slice key={slice.id} data={{ ...slice, uid }} location={location} />
              ))}
            </div>
            {chapterNumber !== chapters.length && (
              <div className="ebook-button-container">
                <Link className="ebook-button new-button" to={generatePath(chapters[chapterNumber].uid)}>
                  {chapters[chapterNumber]?.data?.title?.text}
                  <Image className="ebook-button-image" image={arrow} />
                </Link>
              </div>
            )}
          </div>
        </div>
      </Section>
      <ClosingCtas />
    </Layout>
  )
}

export default Ebook

export const ebookQuery = graphql`
  query EbookBySlug($uid: String!, $ebook_name: String!) {
    chapter: prismicEbook(uid: { eq: $uid }) {
      id
      uid
      prismicId
      data {
        metaTitle: meta_title {
          text
        }
        metaDesc: meta_description {
          text
        }
        ogImage: open_graph_image {
          url
        }
        title {
          html
          text
        }
        ebook_name
        chapter
        chapter_image {
          url
          localFile {
            childImageSharp {
              fluid(maxWidth: 2000, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        body {
          ...EbookWysiwyg
          ...AnchorTitleEbook
          ...ebookBreakoutQuote
        }
      }
    }
    allChapters: allPrismicEbook(
      filter: { data: { ebook_name: { eq: $ebook_name } } }
      sort: { fields: data___chapter, order: ASC }
    ) {
      nodes {
        uid
        data {
          title {
            html
            text
          }
          ebook_name
          chapter
        }
      }
    }
  }
`
